import { render, staticRenderFns } from "./ltxcbk.vue?vue&type=template&id=36bfff3d&scoped=true&"
import script from "./ltxcbk.vue?vue&type=script&lang=js&"
export * from "./ltxcbk.vue?vue&type=script&lang=js&"
import style0 from "./ltxcbk.vue?vue&type=style&index=0&id=36bfff3d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bfff3d",
  null
  
)

export default component.exports